import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PlaceholderModule } from '@headpower/components';
import { Subject, takeUntil } from 'rxjs';
import { CatalogService } from 'src/app/modules/core/services/catalog/catalog.service';
import { FileSaverService } from 'ngx-filesaver';
import { MatButtonModule } from '@angular/material/button';
import { BlahModule } from '@headpower/blah-ng';

@Component({
    selector: 'app-xml-list',
    standalone: true,
    imports: [CommonModule, PlaceholderModule, MatButtonModule, BlahModule],
    templateUrl: './xml-list.component.html',
    styleUrl: './xml-list.component.scss'
})
export class XmlListComponent implements OnInit, OnDestroy {
    private readonly catalogService = inject(CatalogService);
    private readonly fileSaver = inject(FileSaverService);

    public loading: boolean = true;
    private destroy$: Subject<void> = new Subject();
    public instructions = [];

    ngOnInit() {
        this.catalogService.getCatalogsCustom(null)
            .pipe(takeUntil(this.destroy$))
            .subscribe((catalogs) => {
                this.instructions = Object.values(catalogs).flatMap(parent =>
                    (parent.instructions || []).map(instr => ({
                        category: parent.name,
                        name: instr.name,
                        url: location.origin + '/IWI' + instr.href
                    }))
                );

                this.loading = false;
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public generateXml(data) {
        const xmlHeader = `<?xml version="1.0" encoding="UTF-8"?>\n`;

        const linksXml = data.map(link =>
            `<link>
    <name>${this.escapeXml(link.name)}</name>
    <url>${this.escapeXml(link.url)}</url>
    <category>${this.escapeXml(link.category || '')}</category>
</link>`).join('\n');

        return `${xmlHeader}<links>\n${linksXml}\n</links>`;
    }

    public escapeXml(value: string): string {
        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;');
    }

    public downloadXmlFile() {
        const xml = this.generateXml(this.instructions);
        const blob = new Blob([xml], { type: 'application/xml;charset=utf-8' });
        this.fileSaver.save(blob, 'catalog.xml');
    }
}
